// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isLastElement = (array: any[], index: number): boolean =>
  array.length === index + 1
